import React from 'react';
import chargesDoc from 'src/images/Straightline-Accessorial-Charges.pdf';
import shipperPacket from 'src/images/Straightline-Shipper-Packet.pdf';
import TOS from 'src/images/Straightline-Shipper-TOS.pdf';
import { useAppState } from 'src/lib/hooks';
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Formik,
  FormInput,
  FormSubmit,
  Label,
  Row,
  toast,
  useApp
} from 'straightline-ui';
import { yup } from 'straightline-utils/validation';

const schema = yup.object({
  text: yup.string().trim().required().label('Message')
});

export default function Support() {
  const app = useApp();
  const contactService = app.service('api/contact');
  const {
    state: { user }
  } = useAppState();

  const handleSubmit = (data, formik) => {
    contactService
      .create({
        subject: 'New App Contact',
        emails: [process.env.REACT_APP_SUPPORT_EMAIL],
        text: data.text,
        preTag: JSON.stringify(
          {
            user: { id: user.id, email: user.email, full_name: user.full_name }
          },
          null,
          2
        )
      })
      .then((result) => {
        toast.success(`Message Sent! We will get back to you ASAP.`);
        formik.resetForm();
      })
      .catch((err) => {
        toast.errors(err);
        if (err.errors) {
          formik.setErrors(err.errors);
        }
        formik.setSubmitting(false);
      });
  };

  return (
    <Container fluid>
      <div className="header pt-md-2">
        <div className="header-body">
          <h6 className="header-pretitle">Contact Us</h6>
          <h1 className="header-title">How can we help you?</h1>
        </div>
      </div>
      <Row>
        <Col lg="6">
          <Card>
            <CardBody>
              <h3 className="text-uppercase text-muted mb-3">Contact</h3>
              <p className="mb-4">
                Straightline has a team of logistics professionals ready to
                help. Call us any time. We’d love to talk to you.
              </p>
              <p className="mb-1 font-weight-bold">Straightline Memphis</p>
              <p className="mb-1">3750 Hacks Cross Rd</p>
              <p className="mb-1">Suite 102-205</p>
              <p className="mb-1">Memphis, TN 38125</p>
              <p className="mb-1">
                <a href={`tel:${process.env.REACT_APP_SUPPORT_PHONE}`}>
                  {process.env.REACT_APP_SUPPORT_PHONE}
                </a>
              </p>
              <p className="mb-0">
                <a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}>
                  {process.env.REACT_APP_SUPPORT_EMAIL}
                </a>
              </p>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <h3 className="text-uppercase text-muted mb-3">Shipper Packet</h3>
              <p>
                Download our Shipper Packet to get access to all of
                Straightline's DOT, insurance, and legal information.
              </p>
              <a
                href={shipperPacket}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                Download Shipper Packet
              </a>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <h3 className="text-uppercase text-muted mb-3">
                Accessorial Charges
              </h3>
              <p>
                View our Accessorial Charges document to see all of
                Straightline's potential charges.
              </p>
              <a
                href={chargesDoc}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                View Accessorial Charges
              </a>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <h3 className="text-uppercase text-muted mb-3">
                Terms of Service
              </h3>
              <p>
                View and download the latest Straightline terms and conditions.
              </p>
              <a
                href={TOS}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                View Terms of Service
              </a>
            </CardBody>
          </Card>
        </Col>
        <Col xl="5" lg="6">
          <Card>
            <CardBody>
              <h3 className="text-uppercase text-muted mb-3">Holler at us!</h3>
              <Formik
                initialValues={{ text: '' }}
                onSubmit={handleSubmit}
                validationSchema={schema}
                render={({ isSubmitting }) => {
                  return (
                    <Form>
                      <FormGroup>
                        <Label>Message*</Label>
                        <FormInput
                          name="text"
                          type="textarea"
                          placeholder="Report a bug, ask a question, or provide feedback"
                          rows="6"
                          disabled={isSubmitting}
                        />
                        <FormFeedback name="text" />
                      </FormGroup>
                      <FormSubmit className="mr-3">Submit</FormSubmit>
                    </Form>
                  );
                }}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
